import {
  getImageOnlyDimensions,
  getVideoDimensions,
  isVideoMimeType,
} from './imageDimensions';

function normaliseMime(mimeType?: string | null): string | undefined {
  return mimeType?.split(';')[0]?.trim().toLowerCase();
}

function ensureNonEmpty(blob: Blob, context?: string) {
  if (blob.size === 0) {
    const prefix = context ? `${context}: ` : '';
    throw new Error(`${prefix}File is empty`);
  }
}

async function verifyImageDecodable(blob: Blob): Promise<void> {
  if ('createImageBitmap' in window) {
    try {
      const bitmap = await createImageBitmap(blob);
      bitmap.close();
      return;
    } catch {
      // Fall back to DOM decoding for browsers/codecs that reject here.
    }
  }

  try {
    await getImageOnlyDimensions(blob);
  } catch {
    throw new Error('Unable to decode image');
  }
}

async function verifyVideoDecodable(blob: Blob): Promise<void> {
  try {
    await getVideoDimensions(blob);
  } catch {
    throw new Error('Unable to decode video');
  }
}

export async function ensureMediaDecodable(
  file: File | Blob,
  mimeType?: string | null,
  context?: string,
): Promise<void> {
  const blob: Blob = file;
  ensureNonEmpty(blob, context);

  const normalisedType =
    normaliseMime(mimeType) ||
    (file instanceof File ? normaliseMime(file.type) : undefined);

  if (!normalisedType) {
    return;
  }

  if (normalisedType.startsWith('image/')) {
    await verifyImageDecodable(blob);
  } else if (isVideoMimeType(normalisedType)) {
    await verifyVideoDecodable(blob);
  }
}
